export const pageInfo = [
  //
  {
    pageName: "INSERT DATA IN INTERCHANGE TABLE",
    pageUrl: "/InsertData/InterchangeInsertion",
    btnName: "Insert",
    TableName: "railsetu.t_interchange",
  },
  {
    pageName: "INSERT DATA IN PP LOST TRAIN TABLE",
    pageUrl: "/InsertData/PpLostTrainInsertion",
    btnName: "Insert",
    TableName: "railsetu.t_pp_lost_train",
  },
  {
    pageName: "INSERT DATA IN PDD (PRE DETENTION DEPARTURE) TABLE",
    pageUrl: "/InsertData/PDDInsertion",
    btnName: "Insert",
    TableName: "railsetu.t_predeparture_detention",
  },
  {
    pageName: "INSERT DATA IN PW INTERCHANGE (POINT WISE INTERCHANGE) TABLE",
    pageUrl: "/InsertData/PWIInsertion",
    btnName: "Insert",
    TableName: "railsetu.t_pointwise_interchange",
  },
  {
    pageName: "INSERT DATA IN LONGHAUL TAKEN OVER TABLE",
    pageUrl: "/InsertData/LongHaulTOInsertion",
    btnName: "Insert",
    TableName: "railsetu.t_longhaul_takenover",
  },
  {
    pageName: "INSERT DATA IN LONGHAUL HAND OVER TABLE",
    pageUrl: "/InsertData/LongHaulHOInsertion",
    btnName: "Insert",
    TableName: "railsetu.t_longhaul_handover",
  },
  // {
  //   pageName: "INSERT DATA IN NKJ TRAFFIC FLOW TABLE",
  //   pageUrl: "/InsertData/NKJTrafficFlowInsertion",
  //   btnName: "Insert",
  //   TableName: "railsetu.NKJTrafficFlowInsertion",
  // },
  // {
  //   pageName: "INSERT DATA IN NKJ TERMINAL DETENTION TABLE",
  //   pageUrl: "/InsertData/NKJTerminaldetentionInsertion",
  //   btnName: "Insert",
  //   TableName: "railsetu.NKJTerminaldetentionInsertion",
  // },
  // {
  //   pageName: "INSERT DATA IN NKJ EXAMINATION TABLE",
  //   pageUrl: "/InsertData/NKJExaminationInsertion",
  //   btnName: "Insert",
  //   TableName: "railsetu.NKJExaminationInsertion",
  // },

  // ///////////////////////// BLOCK ///////////////////////////////////////////
  {
    pageName: "INSERT DATA IN BLOCK DATA TABLE",
    pageUrl: "/InsertData/BlockDataInsertion",
    btnName: "Insert",
    TableName: "blocks.block_data",
  },

  {
    pageName: "UPDATE DATA OF TWS BLOCK",
    pageUrl: "/InsertData/TWSBlockUpdate",
    btnName: "Update",
    TableName: "blocks.t_tws",
  },
  {
    pageName: "INSERT DATA IN IRE TABLE",
    pageUrl: "/InsertData/IreInsertion",
    btnName: "Insert",
    TableName: "railsetu.t_ire",
  },
  {
    pageName: "INSERT DATA IN ADRM BLOCK POSITION",
    pageUrl: "/InsertData/ADRMBlockPositionInsertion",
    btnName: "Insert",
    TableName: "blocks.t_block_position_adrm_daily",
  },
  {
    pageName: "INSERT DATA IN CRACK TABLE",
    pageUrl: "/InsertData/CrackInsertion",
    btnName: "Insert",
    TableName: "railsetu.t_cracks_hdr",
  },
  {
    pageName: "INSERT DATA IN CREW DEMAND DATA",
    pageUrl: "/InsertData/CrewDemandInsertion",
    btnName: "Insert",
    TableName: "blocks.t_crew",
  },
  {
    pageName: "INSERT DATA IN PATH WASTAGE DATA",
    pageUrl: "/InsertData/PathWastage",
    btnName: "Insert",
    TableName: "blocks.t_path",
  },
  {
    pageName: "INSERT DATA IN NON WORKING DATA",
    pageUrl: "/InsertData/NonWorking",
    btnName: "Insert",
    TableName: "blocks.t_non_working",
  },
  {
    pageName: "MANAGE PDFS",
    pageUrl: "/InsertData/PDFInsertion",
    btnName: "Manage",
    TableName: "railsetu.documents_pdf",
  },
  {
    pageName: "INSERT DATA IN T_RB826",
    pageUrl: "/InsertData/NonWorking",
    btnName: "Insert",
    TableName: "cris_api_data.t_rb826",
  },
  {
    pageName: "INSERT DATA IN TWS CAUTION",
    pageUrl: "/InsertData/TWSCautionInsertion",
    btnName: "Insert",
    TableName: "blocks.t_tws_caution",
  },
  {
    pageName: "INSERT DATA IN ASSET FAILURE TABLE",
    pageUrl: "/InsertData/asset_failure",
    btnName: "Insert",
    TableName: "railsetu.asset_failure",
  },
  /////////////////////////////////
  {
    pageName: "DETAILED TERMINAL DETENTION FOR LOADING",
    pageUrl: "-",
    TableName: "cris_api_data.t_wc006ldng",
  },
  {
    pageName: "DETAILED TERMINAL DETENTION FOR EXAMINATION",
    pageUrl: "-",
    TableName: "cris_api_data.t_wc005exam",
  },
  {
    pageName: "DETAILED TERMINAL DETENTION FOR UNLOADING",
    pageUrl: "-",
    TableName: "cris_api_data.t_wc008ldgn",
  },
  {
    pageName: "WB/TR, POWER HOUSE POSITION,POSITION SHED OUTAGE,",
    pageUrl: "-",
    TableName: "cris_api_data.t_wcrprt057",
  },
  {
    pageName: "HOLDING AND TERRITORIAL OUTRAGE",
    pageUrl: "-",
    TableName: "cris_api_data.t_wcrpt017",
  },
  {
    pageName: "All DETENTION DETAILS,REPORT 16 ",
    pageUrl: "-",
    TableName: "cris_api_data.icms_report16",
  },
  {
    pageName: "All DETENTION DETAILS, REPORT 16 DETENTION",
    pageUrl: "-",
    TableName: "cris_api_data.icms_report16_detention",
  },

  {
    pageName: " ICMS REPORT 02: DETAILS OF PUNCTUALITY",
    pageUrl: "-",
    TableName: "cris_api_data.report02_train_punctuality",
  },
  // {
  //   pageName: "INSERT DATA IN WC007: DETAILS OF TERMINAL DETENTION",
  //   pageUrl: "-",
  //   TableName: "cris_api_data.t_wc007a",
  // },
  {
    pageUrl: "-",
    pageName: "INSERT DATA IN TERMINAL DETENTION OF WC(REVENUE) (WC009A)",
    TableName: "cris_api_data.wc009a_details",
  },
  {
    pageUrl: "-",
    pageName: "COMMODITY WISE FREIGHT LOADING PERFORMANCE (wc547)",
    TableName: "cris_api_data.wc547",
  },
  {
    pageName:
      "SECTION WISE HOR AND SPEED EXCLUDING STABLING YARDING AND ENROUTE DETENTION (wc544)",
    pageUrl: "-",
    TableName: "cris_api_data.wc544",
  },
  {
    pageName: "UNLOADING AGAINST LOADED INWARD (wc420)",
    pageUrl: "-",
    TableName: "cris_api_data.wc420",
  },
  {
    pageName: "LOADING AGAINST EMPTY INWARD (wc420a)",
    pageUrl: "-",
    TableName: "cris_api_data.wc420a",
  },
  {
    pageName: "LOADED STOCK CLEARANCE (wc420b)",
    pageUrl: "-",
    TableName: "cris_api_data.wc420b",
  },
  {
    pageName:
      "INSERT DATA IN SECTION-WISE HOR AND SPEED FOR ALL TRAINS (WC135)",
    pageUrl: "-",
    TableName: "cris_api_data.wc135",
  },
  {
    pageName:
      "WC RAILWAY DIVISION WISE AND 5 BAD CASES IN EACH DIVISION SPEED (wc539)",
    pageUrl: "-",
    TableName: "cris_api_data.wc539_speed",
  },
  {
    pageName: "DETAILS OF LOADED RAKES IN PIPELINE (wc551)",
    pageUrl: "-",
    TableName: "cris_api_data.wc551",
  },
  {
    pageName: "IN FORECAST INTERCHANGE (wc485)",
    pageUrl: "-",
    TableName: "cris_api_data.wc485_dvsn_data",
  },
  // {
  //   pageName: "INSERT DATA IN RAKE TYPEWISE HOLDING AND WTR",
  //   pageUrl: "-",
  //   TableName: "cris_api_data.t_wc538",
  // },
  // {
  //   pageName: "INSERT DATA IN BOOKED AND CARRIED ROUTE VARIATION",
  //   pageUrl: "-",
  //   TableName: "cris_api_data.t_wcrprt549",
  // },
  {
    pageName: "INSERT DATA IN DETAILS OF TERMIANL DETENTION (wcrprt007)",
    pageUrl: "-",
    TableName: "cris_api_data.wcrprt007",
  },
  // {
  //   pageName: "INSERT DATA IN T_WC564 ------",
  //   pageUrl: "-",
  //   TableName: "cris_api_data.t_wc564",
  // },
  {
    pageName: "DATA IN WC555",
    pageUrl: "-",
    TableName: "cris_api_data.wc555",
  },
  ////////////////////////////STATION MAPPING/////////////////////////////////////
  {
    pageName: "INSERT DATA IN STATION MAPPING",
    pageUrl: "/InsertData/SMInsertion",
    btnName: "Insert",
    TableName: "Station_Mapping_data.t_ss",
  },

  // //////////////////////////////////////////dynamicTable///////////////////////////////////////////////////////
  // //////////////////////loading Position////////////////////////////////////////////////////////
  {
    pageName: "INSERT DATA IN commodity Master",
    pageUrl: "/InsertData/lp/DynamicInsertion",
    btnName: "Insert",
    TableName: "dynamicTable.m_commodity",
  },
  {
    pageName: "INSERT DATA IN Wagons Master",
    pageUrl: "/InsertData/lp/DynamicInsertion",
    btnName: "Insert",
    TableName: "dynamicTable.m_wagons",
  },
  {
    pageName: "INSERT DATA IN stations sidings useable Master",
    pageUrl: "/InsertData/lp/DynamicInsertion",
    btnName: "Insert",
    TableName: "dynamicTable.m_stations_sidings_useable",
  },
  {
    pageName: "INSERT DATA IN loading table",
    pageUrl: "/InsertData/lp/DynamicInsertion",
    btnName: "Insert",
    TableName: "dynamicTable.t_loading_hdr",
  },
  // /////////////////////////////////////////////////////////////////////////
  // CLS
  // /////////////////////////////////////////////////////////////////////////

  {
    pageName: "INSERT DATA IN INDENT",
    pageUrl: "/InsertData/CLSInsertion/CLSIndentMaster",
    btnName: "Insert",
    TableName: "CLS.t_indent_hdr",
  },
  {
    pageName: "INSERT DATA IN loading table",
    pageUrl: "/InsertData/lp/ClsLoadingMaster/CLSIndentMaster",
    btnName: "Insert",
    TableName: "CLS.t_loading_hdr",
  },

  // ////////////////////////////////////////////////////////////////////////
  //  store
  // /////////////////////////////////////////////////////////////////////////
  {
    pageName: "INSERT DATA IN Store table 'Division'",
    pageUrl: "/InsertData/Store/StoreInsMaster-division",
    btnName: "Insert",
    TableName: "store.m_store_inventory",
  },
  {
    pageName: "INSERT DATA IN Store table 'Procurement'",
    pageUrl: "/InsertData/Store/Initiate-Procurement",
    btnName: "Insert",
    TableName: "store.m_store_procurement_case",
  },
  {
    pageName: "INSERT DATA IN Store table 'Station'",
    pageUrl: "/InsertData/Store/StoreInsMaster-station",
    btnName: "Insert",
    TableName: "store.m_store_inventory",
  },

  // ////////////////////////////////////////////////////////////////////////
  //  message
  // /////////////////////////////////////////////////////////////////////////

  {
    pageName: "INSERT DATA IN Message table ",
    pageUrl: "/InsertData/MessagingMaster",
    btnName: "Insert",
    TableName: "Message.t_message_",
  },
  {
    pageName: "Update DATA IN Message table ",
    pageUrl: "/InsertData/UpdateMessages",
    btnName: "Update",
    TableName: "Message.t_message_",
  },
];
